import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import { DonutChart } from "@local-logic/core/ui";
import { TranslateIcon } from "@phosphor-icons/react";

import type { Variable } from "@local-logic/client";

import * as styles from "../../styles";

export const SpokenLanguages = () => {
  const { t } = useTranslation("localDemographics");
  const {
    demographicsState: { official_language_knowledge: oficialLanguages },
  } = useDemographics();

  const oficialLanguagesFormatted = useMemo(
    () =>
      oficialLanguages?.variables
        .map((variable: Variable) => ({
          ...variable,
          value: Number((variable.value * 100).toFixed(1)),
        }))
        .filter(
          (variable: Variable) => Number((variable.value * 100).toFixed(1)) > 0
        ),
    [oficialLanguages?.variables]
  );

  const dataset = useMemo(
    () => ({
      labels:
        oficialLanguagesFormatted?.map(
          (variable: Variable) => `${variable.value}% ${variable.label}`
        ) || [],
      data:
        oficialLanguagesFormatted?.map(
          (variable: Variable) => variable.value
        ) || [],
    }),
    [oficialLanguagesFormatted]
  );

  const chartOptions = useMemo(
    () => ({
      title: t("data.languages.graphs.spokenLanguages.title"),
      labels: dataset.labels,
      data: dataset.data,
      icon: <TranslateIcon className={styles.donutChartIcon} />,
    }),
    [dataset]
  );

  return <DonutChart {...chartOptions}></DonutChart>;
};
